import {request} from '@/utils/request'

export default {
  updateDbCache () {
    return request({
      url: '/rest/dbCache/update',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/rest/admin/system.js